// List of all possible result ids for each category
export const categoryResultIdsMapping = {
  app: [1, 2, 3, 4, 5, 6, 7, 128, 129, 130, 131, 132, 133, 134],
  drinks: [8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172],
  mains: [
    17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 135, 136, 137, 138,
    139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149, 150, 151, 152, 153,
    178,
  ],
  stuffing: [31, 32, 33, 34, 35, 36, 37, 38, 39],
  potatoes: [40, 41, 42, 43, 44, 45, 46, 47, 167],
  "sweet-potatoes": [48, 49, 50, 51, 52, 168],
  bread: [53, 54, 55, 56, 57, 58, 59, 165],
  sides: [
    60, 62, 63, 64, 65, 66, 67, 68, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88,
    89, 174, 175, 176, 177,
  ],
  salads: [
    61, 69, 70, 71, 72, 73, 75, 76, 77, 154, 155, 156, 157, 158, 159, 74,
  ],
  cranberry: [90, 91, 92, 93, 160],
  pie: [
    94, 95, 96, 97, 98, 99, 100, 101, 102, 104, 105, 106, 107, 108, 109, 110,
    111, 112, 161, 162, 163, 164,
  ],
  dessert: [
    113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127,
    166, 169,
  ],
}
